import React from "react";
import { Box, Tabs, TabList, TabPanels, TabPanel, Tab, Icon } from "@chakra-ui/react";
import BackgroundImage from "../../../assets/img/longarrow.jpg";

import ManageBankDetailsTab from "../BankDetailsManagement";
import ManageCompanySettingsTab from "../CompanySettingsManagement";
import ManageProtectionTiersTab from "../ProtectionTierManagement";

import { DollarSign, Building2, Shield } from "lucide-react"; 

// Custom Tab Component
const CustomTab = ({ icon, label }) => (
  <Tab
    fontSize="sm"
    color="gray.500"
    _selected={{
      color: "white",
      bg: "transparent",
      backgroundImage: `url(${BackgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    <Icon as={icon} mr={2} />
    {label}
  </Tab>
);

// Main Tabs Component
const CompanyBankTabs = () => {
  return (
    <Box w="100%" p={4} mt="70px" ml="9px">
      <Tabs variant="enclosed">
        <TabList>
          <CustomTab icon={Building2} label="Company Settings" />
          <CustomTab icon={Shield} label="Protection Fee Rates" />
          <CustomTab icon={DollarSign} label="Bank Details" />
        </TabList>

        <TabPanels>
          {/* Company Settings Tab */}
          <TabPanel>
            <ManageCompanySettingsTab />
          </TabPanel>

          {/* Protection Tier Tab */}
          <TabPanel>
            <ManageProtectionTiersTab />
          </TabPanel>

          {/* Bank Details Tab */}
          <TabPanel>
            <ManageBankDetailsTab />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default CompanyBankTabs;